/* unplugin-vue-components disabled */import { render } from "./orderProjectRefund.vue?vue&type=template&id=3553aa3d&scoped=true"
import script from "./orderProjectRefund.vue?vue&type=script&lang=js"
export * from "./orderProjectRefund.vue?vue&type=script&lang=js"

import "./orderProjectRefund.vue?vue&type=style&index=0&id=3553aa3d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3553aa3d"]])

export default __exports__